import React from 'react';

import styled from 'styled-components';

import { IconMobileNavHome } from 'components/icons/mobile-nav-home';
import { IconOffersBk } from 'components/icons/offers-bk';
import { IconOrderBk } from 'components/icons/order-bk';
import { IconRefreshBk } from 'components/icons/refresh-bk';
import { routes } from 'utils/routing';

import { NavLink, iconSize } from './helpers';
import { getAboutLink, getAccountLink } from './nav-links-item';
import { IconWrap, NavLinkText } from './styled';
import { GetNavLinksParams, NavigationMobileTab } from './types';

const BrandLogo = styled(IconMobileNavHome)<{ viewBox: string }>`
  height: 25px;
`;

const homeTextKey = 'home';
const orderTextKey = 'order';
const menuTextKey = 'menu';
const reorderTextKey = 'reorder';
const offersTextKey = 'offers';

export const getNavLinks = ({
  menuHref,
  formatMessage,
  enableAccountInFooter,
  enableOffers,
  enableStaticMenu,
}: GetNavLinksParams): NavigationMobileTab[] => {
  const navRoutes = [
    {
      selectedHrefs: [routes.base],
      Component: () => (
        <NavLink
          data-testid="home-mobile"
          to={routes.base}
          requiresExactMatch
          navBarText={homeTextKey}
        >
          <IconWrap>
            <BrandLogo viewBox="0 0 17 19" />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: homeTextKey })}</NavLinkText>
        </NavLink>
      ),
    },
    {
      selectedHrefs: [menuHref],
      Component: () => (
        <NavLink
          data-testid="order-mobile"
          to={menuHref}
          navBarText={enableStaticMenu ? menuTextKey : orderTextKey}
        >
          <IconWrap>
            <IconOrderBk height={iconSize} />
          </IconWrap>
          <NavLinkText>
            {formatMessage({ id: enableStaticMenu ? menuTextKey : orderTextKey })}
          </NavLinkText>
        </NavLink>
      ),
    },
    {
      selectedHrefs: [routes.orders],
      Component: () => (
        <NavLink data-testid="recent-orders-mobile" to={routes.orders} navBarText={reorderTextKey}>
          <IconWrap>
            <IconRefreshBk width={iconSize} />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: reorderTextKey })}</NavLinkText>
        </NavLink>
      ),
    },
    enableAccountInFooter ? getAccountLink({ formatMessage }) : getAboutLink({ formatMessage }),
  ];

  if (enableOffers) {
    navRoutes.splice(1, 0, {
      selectedHrefs: [routes.offers],
      Component: () => (
        <NavLink data-testid="offers-mobile" to={routes.offers} navBarText={offersTextKey}>
          <IconWrap>
            <IconOffersBk height={iconSize} />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: offersTextKey })}</NavLinkText>
        </NavLink>
      ),
    });
  }

  return navRoutes;
};
